module.exports = __webpack_public_path__ + "images/cv_bulk_arrow_line_f2fe71d78524e05b00d11815cff267f2.png";